import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    activeRoute: ''
}

const activeSlice = createSlice({
    name: 'active',
    initialState,
    reducers: {
        updateActive: (state, action) => {
            //   state.user = action.payload
            //   state.isAuthenticated = true
            return { ...state, ...action.payload };
        },
    },
})

export const { updateActive } = activeSlice.actions
export default activeSlice.reducer